
















































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import GroupCreateApi from '@/app/model/api/groupCreateApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    ErrorInfo
  }
})
export default class GroupCreate extends Vue {
  private group: string = ''
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private show400ErrorMessage: boolean = false

  private async groupCreate () {
    /* バリデーションチェック */
    if (!this.isGroupCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    const bodyData: any = {
      group_name: this.group
    }

    const result = await GroupCreateApi.doGroupCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'グループ登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/group').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      this.alertText = errorData.alertText
      this.alertTitle = errorData.alertTitle
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  private isGroupCreate () {
    const groupNameFlag = Validator.validateInputGroupName('groupNameErrorMessage', this.group)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return groupNameFlag
  }

  private doCancel () {
    this.$router.push('/master/group').catch(e => {})
  }
}
